var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DeviceLayout',{attrs:{"preview-data":{ name: _vm.previewNameLang, type: 'Temperature' },"is-preview":true,"device-icon":"temperature"},scopedSlots:_vm._u([{key:"basic-controls",fn:function(){return [_c('div',{staticClass:"d-flex temperature-sensor"},[_c('div',[_vm._v("20 °C")])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }